import { RestMethod } from '../../../_helpers/ApiConfig/RestMethod'
import FilterResponse from '../../../_helpers/FilterResponse'
import toastr from 'toastr'

export const CMSService = {
    getPageListing,
    updatePage,
    getPageDetail,
    getPageDetailOfCMSbyId,
    addNewaAndUpdates,
    getAllNewsPages,
    getNewsById,
    updateNewaAndUpdates,
    getPageDetailOfCMSby,
    deleteRow,
    getNewsBySlug
}

/**
 * 
 * @Tapas
 * For fetching warehouse list
 */
async function getPageListing(offset, limit) {
    var reuestlink = "/all-content";
    if (offset !== null && limit !== null) {
        reuestlink = reuestlink + "?limit=" + limit + "&offset=" + offset;
    }

    try {
        const response = await RestMethod.GET(reuestlink);
        const api_response = FilterResponse(response); //If respone 200 to 299 Then return 
        return api_response.data;
    }
    catch (error) {
        toastr.error('Something Went Wrong')
        console.log("error detected while fetching data from api");
        return null;
    }
}

async function getAllNewsPages(type, limit, offset) {
    var reuestlink = "/get-all-news-research/" + type + '?';
    if (limit) {
        reuestlink = reuestlink + 'limit=' + limit
    }
    if (offset) {
        reuestlink = reuestlink + '&offset=' + offset
    }
    try {
        const response = await RestMethod.GET(reuestlink);
        const api_response = FilterResponse(response); //If respone 200 to 299 Then return 
        return api_response.data;
    }
    catch (error) {
        toastr.error('Something Went Wrong')
        console.log("error detected while fetching data from api");
        return null;
    }
}

async function getNewsById(id) {
    var reuestlink = "/get-news-research/" + id;

    try {
        const response = await RestMethod.GET(reuestlink);
        const api_response = FilterResponse(response); //If respone 200 to 299 Then return 
        return api_response.data;
    }
    catch (error) {
        toastr.error('Something Went Wrong')
        console.log("error detected while fetching data from api");
        return null;
    }
}

async function getNewsBySlug(id) {
    var reuestlink = "/get-research-detail/" + id;

    try {
        const response = await RestMethod.GET(reuestlink);
        const api_response = FilterResponse(response); //If respone 200 to 299 Then return 
        return api_response.data;
    }
    catch (error) {
        toastr.error('Something Went Wrong')
        console.log("error detected while fetching data from api");
        return null;
    }
}


async function getPageDetail(type) {
    const checkedField = localStorage.getItem("lang") !== null ? localStorage.getItem("lang") : 'en'
    var reuestlink = "/content-detail/" + type + "?lang=" + checkedField;
    try {
        const response = await RestMethod.GET(reuestlink);
        const api_response = FilterResponse(response); //If respone 200 to 299 Then return 
        return api_response.data;
    }
    catch (error) {
        toastr.error('Something Went Wrong')
        console.log("error detected while fetching data from api");
        return null;
    }
}


async function getPageDetailOfCMSbyId(type) {
    var reuestlink = "/content-detail-by-id/" + type;
    try {
        const response = await RestMethod.GET(reuestlink);
        const api_response = FilterResponse(response); //If respone 200 to 299 Then return 
        return api_response.data;
    }
    catch (error) {
        toastr.error('Something Went Wrong')
        console.log("error detected while fetching data from api");
        return null;
    }
}
/**
 * 
 * @param {*} id 
 */
async function updatePage(data) {
    var reuestlink = "/add-content/" + data.id;
    try {
        await RestMethod.PUT(reuestlink, data);
        toastr.success('Page Updated Successfully.')
    }
    catch (error) {
        toastr.error('Something Went Wrong')
        console.log("error detected while fetching data from api");
        return null;
    }
}

async function addNewaAndUpdates(data) {
    var reuestlink = "/add-news";
    try {
        let response = await RestMethod.POST(reuestlink, data);
        toastr.success('Page Updated Successfully.')
        const api_response = FilterResponse(response); //If respone 200 to 299 Then return 
        return api_response.data;
    }
    catch (error) {
        toastr.error('Something Went Wrong')
        console.log("error detected while fetching data from api");
        return null;
    }
}

async function updateNewaAndUpdates(data, id) {
    var reuestlink = "/update-news/" + id;
    try {
        let response = await RestMethod.PUT(reuestlink, data);
        toastr.success('Page Updated Successfully.')
        const api_response = FilterResponse(response); //If respone 200 to 299 Then return 
        return api_response.data;

    }
    catch (error) {
        toastr.error('Something Went Wrong')
        console.log("error detected while fetching data from api");
        return null;
    }
}

async function getPageDetailOfCMSby(type, limit, offset,homeWidget=false) {
    var reuestlink = "/get-all-news-research/" + type + '?';
    if (limit) {
        reuestlink = reuestlink + 'limit=' + limit
    }
    if (offset) {
        reuestlink = reuestlink + '&offset=' + offset
    }
    try {
        const response = await RestMethod.GET(reuestlink);
        const api_response = FilterResponse(response); //If respone 200 to 299 Then return 
        return api_response.data;
    }
    catch (error) {
        if(!false) toastr.error('Something Went Wrong')
        console.log("error detected while fetching data from api");
        return null;
    }
}

async function deleteRow(type) {
    var reuestlink = "/delete-news/" + type;
    try {
        const response = await RestMethod.GET(reuestlink);
        const api_response = FilterResponse(response); //If respone 200 to 299 Then return 
        return api_response.data;
    }
    catch (error) {
        toastr.error('Something Went Wrong')
        console.log("error detected while fetching data from api");
        return null;
    }
}
